import { storage } from 'BASE/common/util/util.storage';
import { lotteryListOder } from 'WX/common/proportionalDividend/proportionalDividend.common';

export default {
    data() {
        return{
            marginInfo: [],
            totalMarginInfo: {
                GameName: '总保证金', 
                Margin: 0
            },
        };
    },
    computed: {
        isAgent() {
            return this.$store.state.userinfo.isAgent;
        },
    },
    methods: {
        async refresh() {
            // if (storage.local.get(storage.keys.ACCESS_TOKEN) && this.isAgent) {
            //     try {
            //         let result = await $.post('/api/ProportionalDividend/GetMarginInfo');
            //         let marginInfo = result.MarginInfo;
            //         let order = lotteryListOder;
            //         if (marginInfo) {
            //             let inOrderList = marginInfo.filter(item => order.indexOf(item.GameID) >= 0);
            //             let notTnOrderList = marginInfo.filter(item => order.indexOf(item.GameID) < 0);
            //             inOrderList.sort((a,b) => {
            //                 return order.indexOf(a.GameID) - order.indexOf(b.GameID);
            //             });
            //             // 沒在排序清單裡面的彩種排最後
            //             this.marginInfo = [...inOrderList, ...notTnOrderList];
            //             // 總保證金額
            //             this.totalMarginInfo.Margin = marginInfo.reduce((acc, curr) => acc + curr.Margin,0);
            //         }
            //     }
            //     catch (err) {
            //         console.error(err);
            //         this.$dialog.warning("查询保证金存入清单失败!");
            //     }
            // }
        }
    },
    watch: {
        isAgent: {
            immediate: true,
            handler() {
                this.refresh();
            },
        }
    },
}